const dates = [
  {
    value: '0',
    label: 'Tutte le date del festival'
  },
  {
    value: '2310',
    label: 'Giovedì 23 ottobre'
  },
  {
    value: '2410',
    label: 'Venerdì 24 ottobre'
  },
  {
    value: '2510',
    label: 'Sabato 25 ottobre'
  },
  {
    value: '2610',
    label: 'Domenica 26 ottobre'
  },
  {
    value: '2710',
    label: 'Lunedì 27 ottobre'
  },
  {
    value: '2810',
    label: 'Martedì 28 ottobre'
  },
  {
    value: '2910',
    label: 'Mercoledì 29 ottobre'
  },
  {
    value: '3010',
    label: 'Giovedì 30 ottobre'
  },
  {
    value: '3110',
    label: 'Venerdì 31 ottobre'
  },
  {
    value: '0111',
    label: 'Sabato 1 novembre'
  },
  {
    value: '0211',
    label: 'Domenica 2 novembre'
  }
];

export default dates;
